import axios from "axios";
import {
    FETCH_CATEGORIA,
    FETCH_LOADING,
    FETCH_ERROR,
} from "../types/types";


export const FetchCategoria = () => async (dispatch) => {
    dispatch({ type: FETCH_LOADING });
    axios.get("https://shoppi-test.herokuapp.com/api/get/categories").then((result) => {
       dispatch({
        type: FETCH_CATEGORIA,
        payload: result.data,
       })    
    })
    .catch(err =>{
        dispatch({
            type: FETCH_ERROR,
            payload: err.message,
        });
    })

}